<template>
    <div>
     <!-- 面包屑导航 -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>监控提醒（用户监控的专利列表）</el-breadcrumb-item>
     </el-breadcrumb>
     <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.zlmc" style="width:110px" placeholder="输入专利名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" style="width:110px" placeholder="输入联系方式"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.zlid" style="width:110px" placeholder="输入专利号"></el-input>
      </el-form-item>
      <el-form-item label="专利类型：">
        <el-select size="small" v-model="formInline.zllx" style="width:100px" placeholder="请选择">
          <el-option v-for="type in zllx" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择截至开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择截至结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="handleExport" title="批量导入监控数据">导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="remindCheck" title="提醒选中的数据">提醒</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="50">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column align="center" prop="zlmc" label="专利名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlid" label="专利号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zllx" label="专利类型" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="username" label="用户昵称" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="userMobile" label="联系方式" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="category" label="待缴费用名目" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="money" label="待缴金额" width="70" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="reptile_current_trial" label="专利状态" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="reptile_update_time" label="更新时间" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="status" label="监控状态" width="80" :formatter="monStatus" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="date_time" label="截至日期" width="90" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="add_time" label="添加时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column align="center" prop="remind_time" label="近期提醒" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" type="warning" @click="handleInput(scope.$index, scope.row)" title="年费录入">录入</el-button>
          <el-button size="mini" type="warning" @click="sendRemind(scope.$index, scope.row)" title="发送提醒">提醒</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlid" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利类型">
              <el-input size="small" v-model="infoForm.zllx" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="待缴费用名目">
              <el-input size="small" v-model="infoForm.category" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="待缴费用金额">
              <el-input size="small" v-model="infoForm.money" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户昵称">
              <el-input size="small" v-model="infoForm.username" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="联系方式">
              <el-input size="small" v-model="infoForm.userMobile" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="添加时间">
              <el-input size="small" v-model="infoForm.add_time" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="截至日期">
              <el-input size="small" v-model="infoForm.date_time" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="近期提醒">
            <el-input size="small" v-model="infoForm.remind_time" auto-complete="off" disabled></el-input>
            </el-form-item>            
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

         <!-- 上传Excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M<button @click="downloadExcel()" style="margin-left: 15px;cursor: pointer">下载模板</button></div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

        <!-- 年费录入界面 -->
    <el-dialog :title="title" :visible.sync="feeFormVisible" width="50%" @click="closeDialog('feeForm')">
    <el-form :model="annualFeeForm" ref="annualFeeForm" label-width="100px" class="demo-dynamic">
            
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="feeForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="feeForm.zlid" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      <el-form-item label="待缴年费">
        <el-row class="demo-autocomplete">
              <el-col :span="6">
                <div class="sub-title" style="color: #909399">费用种类</div>
              </el-col>
              <el-col :span="6">
                <div class="sub-title" style="color: #909399">应缴金额</div>
              </el-col>
              <el-col :span="6">
              <div class="sub-title" style="color: #909399">缴费截止日</div>
            </el-col>
          </el-row>
      </el-form-item>

       <el-form-item
        v-for="(domain, index) in annualFeeForm.pay_able"
        :label="'费用' + index"
        :key="domain.key"
      >
      <el-row class="demo-autocomplete">
            <el-col :span="6">
              <el-input :prop="domain.category" v-model="domain.category" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:发明专利第6年年费"></el-input>
            </el-col>
            <el-col :span="6">
            <el-input :prop="domain.money" v-model="domain.money" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:1200"></el-input>
            </el-col>
            <el-col :span="6">
              <el-input :prop="domain.date" v-model="domain.date" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:2021-05-06"></el-input>
            </el-col>
            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
      </el-row>
        <!-- <el-input v-model="domain.value"></el-input> -->
        
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitFeeForm('annualFeeForm')">提交</el-button>
        <el-button @click="addDomain">新增录入行</el-button>
        <!-- <el-button @click="resetForm('annualFeeForm')">重置</el-button> -->
      </el-form-item>
    </el-form>

    </el-dialog>
    </div>
</template>

<script>
import { 
  webPatList, 
  webSendRemind, 
  webCheckExportMonitor, 
  webExportMonitorAll, 
  webUrl, 
  webPatUpdOneFee, 
  webDownloadPatMonExcel,
  delRemindTrial } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      excelFormVisible: false, //控制批量导入页面显示与隐藏
      feeFormVisible: false, //控制年费录入页面显示与隐藏
      title: '监控详情',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      zllx: [
        { key: '全部', value: 0 },
        { key: '实用新型', value: 1 },
        { key: '发明专利', value: 2 },
        { key: '外观设计', value: 3 }
      ],
      status: [
        { key: '全部', value: 0 },
        { key: '已取消', value: 1 },
        { key: '正常', value: 2 },
        { key: '已失效', value: 4 },
      ],
      infoForm: {
        id: '',
        mobile: '',
        wx_name: '',
        zllx: '',
        zlmc: '',
        zlid: '',
        yjnf: 0,
        znj: 0,
        hfql: 0,
        tjsj: '',
        gqsj: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        zlmc: '',
        mobile: '',
        zllx: '',
        zlid: '',
        origin: 1
      },
      feeForm: {
        zlid: '',
        zlmc: ''
      },
      annualFeeForm: {
          zlid: '',
          pay_able: [{
            category: '',
            money: '',
            date: ''
          }],
        },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      // uploadExcel:webUrl + '/admin/monitor/importPatMonitor',
      uploadExcel:webUrl + '/admin/monitor/importPatMonExcel',
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      if(parameter.start_time == null){
            parameter.start_time = 0
      }
      if(parameter.end_time == null){
            parameter.end_time = 0
      }
      webPatList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //导出excel
    exportCheck() {
      //判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
      //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定导出勾选的记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const exportParam = {ids:idStr}
          webCheckExportMonitor(exportParam)
                  .then(res => {
                    res = checkLogin(res)
                    if (res.code == 200) {
                      location.href = res.data.url
                      this.$message({
                        type: 'success',
                        message: '导出成功!'
                      })
                    } else {
                      this.$message({
                        type: 'info',
                        message: res.msg
                      })
                    }
                  })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    exportAll() {
      this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
          if(this.formInline.start_time == null){
                this.formInline.start_time = 0
          }
          if(this.formInline.end_time == null){
                this.formInline.end_time = 0
          }
            webExportMonitorAll(this.formInline)
              .then(res => {
                if (res.code == 200) {
                  location.href = res.data.url
                  this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 显示Excel导入页面
    handleExport: function(){
      this.title = '批量导入Excel'
      this.excelFormVisible = true
    },
    // 删除监控记录
    delMonitor(index, row) {
      this.$confirm('确定删除该记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(()=>{
        let param = {
          id: row.id
        }
        delRemindTrial(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.search()
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 提醒勾选中的记录
    remindCheck(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
     //根据不同值显示不同文本内容
    monStatus(row,column){
      if(row.status == 1){
          return '已取消'
      }else if(row.status == 2){
          return '正常'
      }else if(row.status == 4){
          return '已失效'
      }else{
          return '未知'
      }
    },
    // 发送提醒
    sendRemind: function(index,row){
    const sendParam = {
        id:row.id
    }
    this.$confirm('确定发送提醒吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          webSendRemind(sendParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消提醒'
          })
        })
    },
        //显示年费录入界面
    handleInput: function(index,row){
        if(row.status == 4 || row.status == 5){
            this.$message({
                type: 'info',
                message: '该状态不支持录入!'
            })
            return false
        }
        this.title = '年费录入'
        this.feeFormVisible = true
        this.feeForm = row
        this.annualFeeForm.zlid = row.zlid
        if(row.pay_able !== null){
        this.annualFeeForm.pay_able = row.pay_able
        }else{
          // 没有数据需要初始化,防止之前的数据回显
         this.annualFeeForm.pay_able = [{
            category: '',
            money: '',
            date: ''
          }]
        }
    },
    submitFeeForm(formName) {
      this.$refs[formName].validate((valid) => {
      console.log(valid)
      if (valid) {
      const param = { zlid:this.annualFeeForm.zlid,pay_able:JSON.stringify(this.annualFeeForm.pay_able) }
      webPatUpdOneFee(param)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.feeFormVisible = false
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      if (index !== -1) {
        this.annualFeeForm.pay_able.splice(index, 1)
      }
    },
    addDomain() {
      this.annualFeeForm.pay_able.push({
        key: Date.now()
      });
    },
    // 下载监控导入excel模板
    downloadExcel(){
      webDownloadPatMonExcel()
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '模板下载成功!'
              })
              window.location.href = res.data.value
          } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/patent/Patentremind.vue